import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from "@mui/material";
import { withStyles } from "tss-react/mui";

const NextModuleModal = ({ isOpen, onClose, onStart, testSetInfo }) => {
    return (
        <CustomDialog
            open={!!isOpen}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {/* Header */}
            <DialogTitle
                id="alert-dialog-title"
                className="text-center font-bold text-lg flex items-center justify-center gap-2"
            >
                Next Module
            </DialogTitle>

            {/* Content */}
            <DialogContent>
                <CustomDialogContentText>
                    <div style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#fff' }}>
                        {testSetInfo.seriesName} <span style={{ color: '#90caf9' }}>{'>'}</span> {testSetInfo.testSetName}
                    </div>
                    <p style={{ marginTop: 12, color: '#aaa', fontSize: '0.9rem' }}>
                        You have completed this module. Continue to the next module to keep learning.
                    </p>
                </CustomDialogContentText>
            </DialogContent>

            {/* Actions */}
            <DialogActions className="justify-center pb-2">
                <Button
                    variant="contained"
                    onClick={onStart}
                    color="primary"
                    className="px-6 py-2 rounded-xl shadow-md"
                >
                    Start Next Module
                </Button>
                <Button
                    variant="contained"
                    onClick={onClose}
                    color="secondary"
                    className="px-6 py-2 rounded-xl shadow-md"
                >
                    Cancel
                </Button>
            </DialogActions>
        </CustomDialog>
    )
}

export default NextModuleModal

// Dialog style
const CustomDialog = withStyles(
    Dialog,
    () => ({
        paper: {
            borderRadius: 16,
            padding: "8px 12px",
            backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.16));",
            color: "#fff",
            boxShadow: "0 8px 24px rgba(0,0,0,0.6)",
            minWidth: 360,
        }
    })
);

// ContentText style
const CustomDialogContentText = withStyles(
    DialogContentText,
    () => ({
        root: {
            marginTop: 10,
            color: "#ddd",
            textAlign: "center",
        }
    })
);
